import { createContext } from 'react';

import { Device } from 'scripts/lib/device_detector';

// Default to Desktop so consumers behave like the pre-phone-shell app when
// DeviceProvider isn't mounted (e.g. orgs without the frontendPhoneSupport
// gatekeeper flag enabled, or pre-auth pages like login that intentionally
// don't consume DeviceContext). DeviceProvider overrides this with the live
// value when it is mounted.
const DeviceContext = createContext(Device.Desktop);

DeviceContext.displayName = 'DeviceContext';

export default DeviceContext;
export { Device };
